import script from "./VendorDetail009.vue?vue&type=script&setup=true&lang=js"
export * from "./VendorDetail009.vue?vue&type=script&setup=true&lang=js"

import "./VendorDetail009.vue?vue&type=style&index=0&id=7cb4457a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cb4457a"]])

export default __exports__